function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { getStatusBarHeight, getPaddingFromStatusBar } from '../../constants';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
import { View, StatusBar, TouchableOpacity, StyleSheet } from 'react-native';
import { increasedTapZone } from '../../common';

const Header = _ref => {
  let {
    leftComponent,
    rightComponent,
    translucent = false,
    barStyle = 'light-content',
    theme: {
      colors
    },
    title,
    titleAccessibility
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, {
      backgroundColor: colors.background.headerModal
    }]
  }, /*#__PURE__*/React.createElement(StatusBar, {
    barStyle: barStyle,
    translucent: translucent
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      width: 70
    }
  }, (leftComponent === null || leftComponent === void 0 ? void 0 : leftComponent.icon) && /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    accessibilityRole: 'button'
  }, increasedTapZone(), leftComponent.accessibility, {
    style: styles.leftViewButton,
    onPress: leftComponent === null || leftComponent === void 0 ? void 0 : leftComponent.action
  }), leftComponent.icon)), /*#__PURE__*/React.createElement(View, {
    style: styles.titleView
  }, /*#__PURE__*/React.createElement(Text, _extends({}, titleAccessibility, {
    style: {
      textAlign: 'center'
    },
    type: TextType.Subtitle,
    color: colors.text.ondark,
    numberOfLines: 1
  }), title)), /*#__PURE__*/React.createElement(View, {
    style: {
      width: 70
    }
  }, (rightComponent === null || rightComponent === void 0 ? void 0 : rightComponent.icon) && /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    accessibilityRole: 'button'
  }, rightComponent.accessibility, {
    style: styles.rightViewButton,
    onPress: rightComponent === null || rightComponent === void 0 ? void 0 : rightComponent.action
  }), rightComponent.icon)));
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingTop: getStatusBarHeight() + getPaddingFromStatusBar(),
    paddingBottom: 20,
    alignItems: 'center',
    width: '100%'
  },
  leftViewButton: {
    justifyContent: 'center',
    paddingLeft: 24
  },
  rightViewButton: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingRight: 24
  },
  titleView: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  }
});
export default withTheme(Header);
//# sourceMappingURL=ModalHeader.js.map